import { Component, ViewChild, Injector, Output, EventEmitter, ViewEncapsulation} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/common/app-component-base';
@Component({
    selector: 'workFlowItemApproveModal',
    styleUrls: ['./workFlowItem-approve-modal.component.less'],
    templateUrl: './workFlowItem-approve-modal.component.html',
    encapsulation: ViewEncapsulation.None
})
export class WorkFlowItemApproveModalComponent extends AppComponentBase {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;


    title = '';
    description = '';



    constructor(
        injector: Injector
    ) {
        super(injector);
    }
    
    show(itemTilte?: string,itemDescription?: string): void {
    
        const options = { windowClass: 'custom-ngb-modal-window', backdropClass: 'custom-ngb-modal-backdrop' };

        this.title = itemTilte;
        this.description = itemDescription;

        this.active = true;
        this.modal.show();
        
        
        
    }

    save(): void {
            this.saving = true;
            
			this.modalSave.emit(this.description);
			this.close();
            
    }

    




    close(): void {
        this.active = false;
        this.modal.hide();
    }
    
     ngOnInit(): void {
        
     }   
}
